import styled from 'styled-components';
import {
  colorsVariables,
  gutterVariables
} from '@trustedshops/tps-seo-shared-frontend-react-components';
import { minWidth as minWidthGenerator } from 'helpers/buildMediaQueries';
import {
  headerVariables,
  navigationHeightsValues
} from 'styles/header.variables';
import { iconVariables } from 'styles/icon.variables';

/*
 * margin-bottom explanation:
 * viewBox="0 0 1440 63"
 * leads to
 * 63 / 1440 = 0,04375px height per 1px width
 * = 4,375 height for 100px width
 * */
const paddingMediaQueries = navigationHeightsValues
  .map(({ minWidth, height }) =>
    minWidthGenerator(
      minWidth,
      `padding: ${height}px ${gutterVariables.GUTTER} ${gutterVariables.GUTTER} ${gutterVariables.GUTTER};`
    )
  )
  .join('');

export const Header = styled.header`
  background: ${colorsVariables.PINEAPPLE_500};
  position: relative;
  margin-bottom: 4.375vw;
  display: grid;
  grid-area: 1 / 1 / 2 / 2;
  ${minWidthGenerator('sm', 'grid-area: 1 / 1 / 2 / 5;')}
  ${headerVariables.gridTemplates}
  ${paddingMediaQueries}

  h1 {
    grid-area: 1 / 2 / 1 / 2;
    text-align: center;
    margin: ${gutterVariables.GUTTER} auto;
    width: 100%;

    ${minWidthGenerator('sm', 'width: 83.33%;')}
    ${minWidthGenerator('md', 'margin-bottom: 16px;')}
    ${minWidthGenerator('xl', 'margin-top: 32px;')}
  }

  form {
    justify-self: center;
    grid-area: 2 / 2 / 2 / 2;
  }

  .logo {
    float: left;
    font-size: 200%;
  }

  .hls:before {
    line-height: ${iconVariables.LINE_HEIGHT_INHERIT};
  }
`;
